import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/googleAnalytics';

/**
 * Hook personalizado para rastrear visualizações de página
 * Rastreia automaticamente quando a rota muda
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Rastreia a visualização da página sempre que a localização mudar
    const path = location.pathname + location.search;
    trackPageView(path);
  }, [location]);
};
